import {NgModule} from '@angular/core';
import {SpecialistSizesValuesService} from './specialist-sizes-values/specialist-sizes-values.service';
import {SpecialistSizesValuesProvider} from './specialist-sizes-values/specialist-sizes-values.provider';
import {SpecialistsService} from './specialists/specialists.service';
import {SpecialistsProvider} from './specialists/specialists.provider';
import {ObjectsService} from './objects/objects.service';
import {ObjectsProvider} from './objects/objects.provider';
import {MethodsResolverService} from './_resolvers/methods-resolver.service';
import {MethodsService} from './methods/methods.service';
import {MethodsProvider} from './methods/methods.provider';
import {PermitTypesProvider} from './education-types/permit-types.provider';
import {SpecialistStatusesProvider} from './specialist-statuses/specialist-statuses.provider';
import {EquipmentStatusesProvider} from './equipment-statuses/equipment-statuses.provider';
import {JobService} from './job/job.service';
import {JobProvider} from './job/job.provider';
import {EducationLevelService} from './education-level/education-level.service';
import {EducationLevelProvider} from './education-level/education-level.provider';
import {TerritorialAuthorityService} from './territorial-authority/territorial-authority.service';
import {TerritorialAuthorityProvider} from './territorial-authority/territorial-authority.provider';
import {BusinessStructureService} from './business-structure/business-structure.service';
import {BusinessStructureProvider} from './business-structure/business-structure.provider';
import {MethodLevelsProvider} from './method-levels/method-levels.provider';
import {EquipmentTypesProvider} from './equipment-types/equipment-types.provider';
import {EquipmentLeasedTypeProvider} from './equipment-leased-type/equipment-leased-type.provider';
import {MeasureUnitProvider} from './measure-unit/measure-unit.provider';
import {MeasureUnitService} from './measure-unit/measure-unit.service';
import {NotificationsService} from './notifications/notifications.service';
import {NotificationsProvider} from './notifications/notifications.provider';
import {
    EquipmentCalibrationExpirationStatusProvider
} from '@providers/equipment-calibration-expiration-status/equipment-calibration-expiration-status.provider';
import {TechnicalDocumentsProvider} from '@providers/technical-documents/technical-documents.provider';
import {TechnicalDocumentsService} from '@providers/technical-documents/technical-documents.service';
import {TechnicalDocumentsResolverService} from '@providers/_resolvers/technical-documents-resolver.service';
import {ObjectsResolverService} from '@providers/_resolvers/objects-resolver.service';
import {SpecialistsResolverService} from '@providers/_resolvers/specialists-resolver.service';
import {BusinessStructuresResolverService} from '@providers/_resolvers/business-structures-resolver.service';
import {LaboratoryDocumentsTypesProvider} from '@providers/laboratory-documents-types/laboratory-documents-types.provider';
import {LaboratoryDocumentsProvider} from '@providers/laboratory-documents/laboratory-documents.provider';
import {LaboratoryDocumentsService} from '@providers/laboratory-documents/laboratory-documents.service';
import {LaboratoryDocumentsResolverService} from '@providers/_resolvers/laboratory-documents-resolver.service';
import {WorkingObjectsStatusesProvider} from '@providers/working-objects-statuses/working-objects-statuses.provider';
import {UsersRolesResolverService} from '@providers/_resolvers/users-roles-resolver.service';
import {UsersRolesService} from '@providers/users-roles/users-roles.service';
import {TechnicalDeviceDocumentTypesProvider} from '@providers/dechnical-device-document-types/technical-device-document-types.provider';
import {TechnicalDeviceDocumentTypesService} from '@providers/dechnical-device-document-types/technical-device-document-types.service';
import {LaboratoryResponsibleStaffResolverService} from '@providers/_resolvers/laboratory-responsible-staff-resolver.service';
import {LaboratoryResponsibleStaffTypesResolverService} from '@providers/_resolvers/laboratory-responsible-staff-types-resolver.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        SpecialistSizesValuesService,
        SpecialistSizesValuesProvider,

        SpecialistsService,
        SpecialistsProvider,
        SpecialistsResolverService,

        ObjectsService,
        ObjectsProvider,
        ObjectsResolverService,

        MethodsService,
        MethodsProvider,
        MethodsResolverService,

        PermitTypesProvider,

        EquipmentStatusesProvider,
        SpecialistStatusesProvider,

        JobService,
        JobProvider,

        EducationLevelService,
        EducationLevelProvider,

        TerritorialAuthorityService,
        TerritorialAuthorityProvider,

        TechnicalDocumentsService,
        TechnicalDocumentsProvider,
        TechnicalDocumentsResolverService,

        BusinessStructureService,
        BusinessStructureProvider,
        BusinessStructuresResolverService,

        EquipmentTypesProvider,

        MethodLevelsProvider,

        EquipmentLeasedTypeProvider,

        MeasureUnitProvider,
        MeasureUnitService,

        NotificationsService,
        NotificationsProvider,

        EquipmentCalibrationExpirationStatusProvider,

        LaboratoryDocumentsTypesProvider,

        LaboratoryDocumentsService,
        LaboratoryDocumentsProvider,
        LaboratoryDocumentsResolverService,

        UsersRolesService,
        UsersRolesResolverService,

        WorkingObjectsStatusesProvider,

        TechnicalDeviceDocumentTypesService,
        TechnicalDeviceDocumentTypesProvider,

        LaboratoryResponsibleStaffResolverService,
        LaboratoryResponsibleStaffTypesResolverService,
    ],
})
export class ProvidersModule {
}
